module.exports = __webpack_public_path__ + "static/media/cat.08c50ee4.svg";